import React from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { callTrackingWithFbclid } from "../hooks/useFbclid";

const withRouter = (WrappedComponent: any) => (props: any) => {
  const { id, c } = useParams();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const prompt = searchParams.get("prompt");
  const send = searchParams.get("send");
  const bookTalk = searchParams.get("bookTalk");

  const action = searchParams.get("action");
  const user_id = searchParams.get("user_id");

  const openChatPointBooster = searchParams.get("chatpoint-booster");

  const navigate = useNavigate();

  const updateParams = (newParams: any) => {
    const newSearchParams = new URLSearchParams(searchParams.toString());
    for (const key in newParams) {
      newSearchParams.set(key, newParams[key]);

      // Check if the key is "prompt" and its value matches
      if (
        key === "prompt" &&
        newParams[key] === "Serious Trouble - Chapter 4"
      ) {
        callTrackingWithFbclid("View content", "Quin Toro");
      }
      if (
        key === "prompt" &&
        newParams[key] === "Serious Trouble - Chapter 16"
      ) {
        callTrackingWithFbclid("Complete registration", "Quin Toro");
      }
    }

    navigate(location.pathname + "?" + newSearchParams.toString());
  };

  return (
    <WrappedComponent
      navigate={navigate}
      id={id}
      prompt={prompt}
      send={send}
      bookTalk={bookTalk}
      action={action}
      c={c}
      user_id={user_id}
      updateParams={updateParams}
      {...props}
      location={location}
      openChatPointBooster={openChatPointBooster}
    />
  );
};

export default withRouter;
